<template>
  <el-dialog
    :title="'备注'"
    :visible="true"
    :before-close="closeForm"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    width="20%"
  >
    <el-form
      :model="refundFrom"
      :rules="rules"
      ref="refundFrom"
      label-width="50"
      class="demo-refundFrom"
    >
      <el-form-item label="备注" prop="remark">
        <el-input
          v-model.trim="refundFrom.remark"
          :rows="3"
          maxlength="200"
          show-word-limit
          type="textarea"
        ></el-input>
      </el-form-item>
      <div class="align-center">
        <el-button type="primary" @click="submitForm()">确定</el-button>
        <el-button @click="closeForm()">取消</el-button>
      </div>
    </el-form>
  </el-dialog>
</template>

<script>
export default {
  props: ["refund"],
  data() {
    return {
      refundFrom: {
        id: this.refund ? this.refund.id : "",
        remark: this.refund ? this.refund.remark : ""
      },
      rules: {}
    };
  },
  methods: {
    submitForm() {
      console.log("--------------");
      console.log(this.refundFrom.remark);
      // if (this.refundFrom.remark == "") {
      //   alert("请输入内容！");
      //   return;
      // }
      let remarkRequestModel = {
        id: this.refundFrom.id,
        remark: this.refundFrom.remark
      };
      this.$axios(this.$urlMapping["设置退款备注"], {
        data: remarkRequestModel
        // eslint-disable-next-line no-unused-vars
      }).then(result => {
        this.$notifySuccess();
        this.$emit("closeForm");
        // this.$emit("onSubmit");
      });
    },
    closeForm() {
      this.$emit("closeForm");
    }
  }
};
</script>

<style lang="less" scoped></style>
